import axios, {  } from 'axios'; // AxiosError lol
import type { RidesData } from '../types/ride';

const api = axios.create({
  baseURL: 'https://frappe.kry.bz/api/method/bmapp.utils.api.get_mitfahrten',
});

export async function fetchRides(): Promise<{ data: RidesData | null; error: string | null; maintenance: boolean }> {
  try {
    const response = await api.get('');
    return { 
      data: response.data?.message || { from_bm: [], to_bm: [] },
      error: null,
      maintenance: false
    };
  } catch (error) {
    console.error('Error fetching rides:', error);
    
    // Always set maintenance mode on any error
    return { 
      data: null, 
      error: null,
      maintenance: true
    };
  }
}